import { Box, Stack, Typography } from '@mui/material';
import IconLibrary from '../../IconLibrary';
import { formatUSPhoneNumber } from '../PhoneNumber';

function MainContactCard({ user = null }) {
  const firstName = user?.firstName;
  const lastName = user?.lastName;
  const email = user?.email;
  const phoneNumber = user?.phoneNumber;

  return (
    <Box>
      <Stack direction="column" spacing={1}>
        {(firstName || lastName) && (
          <Stack direction="row" spacing={1} alignItems="center">
            <IconLibrary.User
              sx={{ fontSize: '20px', color: 'text.secondary' }}
            />
            <Stack direction="row" spacing={0.5}>
              {firstName && <Typography>{firstName}</Typography>}
              {lastName && <Typography>{lastName}</Typography>}
            </Stack>
          </Stack>
        )}
        {email && (
          <Stack direction="row" spacing={1} alignItems="center">
            <IconLibrary.Email
              sx={{ fontSize: '18px', color: 'text.secondary' }}
            />
            <Typography>{email}</Typography>
          </Stack>
        )}
        {phoneNumber && (
          <Stack direction="row" spacing={1} alignItems="center">
            <IconLibrary.Phone
              sx={{ fontSize: '18px', color: 'text.secondary' }}
            />
            <Typography>{formatUSPhoneNumber(phoneNumber)}</Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
}

export default MainContactCard;
